import React, { useState, useRef, useEffect } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";
import { Submissionbtn } from "../../components/buttons";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { manufacturingServices } from "../../services/manufacturingServices";
import { manufacturerServices } from "../../services/manufacturerServices";
import { freightServices } from "../../services/freightServices";
import { useSelector } from 'react-redux';

import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import  { useLocation } from "react-router";
import { shipmentServices } from "../../services/shipmentServices";

function EditShipment() {
  const location = useLocation(null); 
  const unitreducer = useSelector((state)=>state.unitreducer); 
  const currencyreducer = useSelector((state)=>state.currencyreducer);
  const [currencies,setCurrencies] = useState([]);
  const toast = useRef(null);
  const [errors, setErrors] = useState({});
  const [productnamesku, setProductnamesku] = useState('');
  const [productlist,setProductlist] = useState([]);
  const [freightlist,setFreightlist] = useState([]);
  const [is_self_courier,setIsselfcourier] = useState(true);
  const [submitted,setSubmitted] = useState(true);


  const [formData, setFormData] = useState({
    freight_provider_id: "",
    shipment_reference: "",
    origin: "",
    fright_currency:'',
    freight_cost: "",
    tracking_number: "",
    shipment_date: "",
    status: "",
    street_address:'',
    city:"",
    state:"",
    postal_code:""
  });


  useEffect(()=>{
    console.log('shipment');
    console.log(location.state?.shipment);
    getcurrency();
    setFormData(location.state?.shipment);
    getfreightlist()
    getshipment();
    
  },[]);


  useEffect(()=>{
      let search = location.state?.shipment.freight_provider_id;
      let is_self_courier = false;
      freightlist.forEach((value,index)=>{
          if(value.id == search){
            value.services.forEach((valueinner,index)=>{
                 if(valueinner.code == 'self_courier'){
                        is_self_courier = true;
                 }else{
                       is_self_courier = false;
                 }
            })
          }  
      })
      setIsselfcourier(is_self_courier);
     
  },[freightlist])

const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
     if(name == 'freight_provider_id'){
      let search = value;
      let is_self_courier = false;
      freightlist.forEach((value,index)=>{
          if(value.id == search){
            value.services.forEach((valueinner,index)=>{
                 if(valueinner.code == 'self_courier'){
                        is_self_courier = true;
                 }else{
                       is_self_courier = false;
                 }
            })
          }  
      })
      setIsselfcourier(is_self_courier); 
    }
};


  const validate = () => {
    const newErrors = {};
    if (!formData.freight_provider_id) newErrors.freight_provider_id = "Freight provider is required";
    if (!formData.shipment_reference) newErrors.shipment_reference = "Shipment reference is required";
    if (!formData.origin ) newErrors.origin = "Origin is required";

    if (!formData.freight_cost) newErrors.freight_cost = "Freight cost is required";
    if (!formData.tracking_number) newErrors.tracking_number = "Tracking number is required";
    if (!formData.status) newErrors.status = "Status is required";
    if (!formData.shipment_date) newErrors.shipment_date = "Shipment date is required";
    if (!formData.street_address) newErrors.street_address = "Street Address is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.postal_code) newErrors.postal_code = "Postal Code is required";

    return newErrors;
  };

  const refs = {
    freight_provider_id: useRef(null),
    shipment_reference: useRef(null),
    origin: useRef(null),
    // date: useRef(null),

    freight_cost: useRef(null),
    tracking_number: useRef(null),
    status: useRef(null),
    street_address:useRef(null),
    city:useRef(null),
    state:useRef(null),
    postal_code:useRef(null),
  };


  const handlesubmit = (e) => {
     e.preventDefault();
        const validationErrors = validate();
          setErrors(validationErrors);
         
    //     if (Object.keys(validationErrors).length > 0) {
    //   // Focus first input with error
    //       const firstErrorKey = Object.keys(validationErrors)[0];
    //       if (refs[firstErrorKey]) {
    //         refs[firstErrorKey].current.focus();
    //       }
    //   return;
    // }
    let dataToSend = { ...formData };
    console.log(dataToSend)
    setSubmitted(false);
        shipmentServices.updateshipment(dataToSend).then((response)=>{
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Shipment', detail: 'Shipment updated successfully' }); 
                setSubmitted(true);
            }else{
                toast.current.show({ severity: 'error', summary: 'Shipment', detail: `${response.data.data}` }); 
                setSubmitted(true);
            }   
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Shipment', detail: 'Error' }); 
            setSubmitted(true);
        });
    

    // Handle form submission here
  };


  const getshipment = () =>{
      let id = location.state?.shipment.shipment_id ?? location.state?.shipment.id;
      shipmentServices.getshipment('','',{id:id}).then((response)=>{
          if(response.status == 200){
              setFormData((prevData) =>{
                  return{
                      ...prevData,
                      fright_currency:response.data.data.fright_currency,
                      status:response.data.data.status
                  }
              });
              console.log(formData)
          }else{
              
          }   
      }).catch((error)=>{
          
      });
  }

  

  const getfreightlist = () =>{
    shipmentServices.getfreightlist().then((response)=>{
      console.warn(response);
        if(response.status ==200){
            setFreightlist(response.data.data);  
        }else{
            setFreightlist([]); 
        }
         
      }).catch((error)=>{
            setFreightlist([]); 
      });
  }

  const getcurrency = () => {
    currencyreducer.then((response)=>{
        setCurrencies(response);
      }).catch((error)=>{
    });
   } 

  const displayCurrency = () => {
    let items = [];
    currencies.forEach((value,index)=>{
       items.push(<option key={index} value={value.code}>{value.code}</option>);
    })  
    return items;
  }

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Shipment / Edit Shipment"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        {/* <Titlebar text={"Edit Shipment"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>
                <form onSubmit={(e) => handlesubmit(e)}>
                        <div class="row mb-3">
                           <div class="col-md-6">
                              <label for="freight_provider_id" class="form-label">Freight Provider</label>
                              <select class="form-select" id="freight_provider_id" name="freight_provider_id" disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }
                              ref={refs.freight_provider_id}  onChange={handleChange} value={formData.freight_provider_id}>
                                  <option value="">Select Type</option> 
                                  {freightlist.map((row,index)=>
                                  <option value={row.id} key={index}>{row.name}</option>
                                  )}  
                              </select>
                              {errors.freight_provider_id && <span style={{ color: "red" }}>{errors.freight_provider_id}</span>}
                            </div>
                            <div class="col-md-6">
                              <label for="Po Number" class="form-label">Po Number </label>
                              <input type="text" disabled  onChange={handleChange} ref={refs.ponumber} class="form-control"
                               value={formData.ponumber}
                               id="ponumber" name="ponumber" placeholder="Po Number"/>
                            </div>

                            <div class="col-md-6">
                              <label for="shipment_reference" class="form-label">Shipment Reference </label>
                              <input type="text" disabled required  onChange={handleChange} ref={refs.shipment_reference} class="form-control"
                               id="shipment_reference" value={formData.shipment_reference} name="shipment_reference" placeholder="Enter shipment reference"/>
                              {/* {errors.shipment_reference && <span style={{ color: "red" }}>{errors.shipment_reference}</span>} */}
                            </div>   
                            <div class="col-md-6">
                              <label for="origin" class="form-label">Origin, <span className="text-info">(Addresses should be comma-separated.)</span></label>
                              <input type="text"  onChange={handleChange} disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true } ref={refs.origin} class="form-control"
                               id="origin" name="origin" placeholder="Enter Origin" value={formData.origin}/>
                              {errors.origin && <span style={{ color: "red" }}>{errors.origin}</span>}
                            </div>   

                            {/* <div class="col-md-6">
                              <label for="shipment_reference" class="form-label">Shipment Reference </label>
                              <input type="text"  onChange={handleChange} value={formData.shipment_reference} ref={refs.shipment_reference} class="form-control"
                               id="shipment_reference" name="shipment_reference" placeholder="Enter shipment reference"/>
                              {errors.shipment_reference && <span style={{ color: "red" }}>{errors.shipment_reference}</span>}
                            </div> */}
                        </div>

                       
                       <div className="row">
                              <p className="text-success">Shipping Address :</p>
                              <div class="row mb-3">
                                  <div class="col-md-6">
                                  <label for="street_address" class="form-label">Street Address</label>
                                  <input
                                      type="text"
                                      ref={refs.street_address}
                                      class="form-control"
                                      id="street_address"
                                      name="street_address"
                                      placeholder="Enter Street Address"
                                      value={formData.street_address}
                                      disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }
                                      onChange={handleChange}
                                  />
                                  {errors.street_address && <span style={{ color: "red" }}>{errors.street_address}</span>}
                              </div>
                             </div>

                              <div class="row mb-3">
                          <div class="col-md-3">
                              <label for="city" class="form-label">City</label>
                              <input
                                  type="text"
                                  ref={refs.city}
                                  class="form-control"
                                  id="city"
                                  name="city"
                                  placeholder="Enter City"
                                  value={formData.city}
                                  disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }
                                  onChange={handleChange}
                              />
                              {errors.city && <span style={{ color: "red" }}>{errors.city}</span>}
                          </div>

                          <div class="col-md-3">
                              <label for="state" class="form-label">State/Province</label>
                              <input
                                  type="text"
                                  ref={refs.state}
                                  class="form-control"
                                  id="state"
                                  name="state"
                                  placeholder="Enter State/Province"
                                  value={formData.state}
                                  disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }
                                  onChange={handleChange}
                              />
                              {errors.state && <span style={{ color: "red" }}>{errors.state}</span>}
                          </div>
                  
                          <div class="col-md-3">
                              <label for="postal_code" class="form-label">Postal Code</label>
                              <input
                                  type="text"
                                  ref={refs.postal_code}
                                  class="form-control"
                                  id="postal_code"
                                  name="postal_code"
                                  placeholder="Enter Postal Code"
                                  value={formData.postal_code}
                                  disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }
                                  onChange={handleChange}
                              />
                              {errors.postal_code && <span style={{ color: "red" }}>{errors.postal_code}</span>}
                          </div>
                        </div>
                        </div>       
                       
                       
                        <div class="row mb-3">
                            
                             
                              {is_self_courier ? (<>
                              <div class="col-md-6">
                                  <label for="freight_cost" class="form-label">Freight Cost</label>
                                  <div className="flex-box">
                                      <select className="form-control" name="fright_currency" style={{width:'60px'}} onChange={handleChange}  value={formData.fright_currency} disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }>
                                        {displayCurrency()}

                                      </select>

                                     <input type="number" placeholder="Enter Freight Cost" ref={refs.freight_cost} class="form-control" id="freight_cost" disabled
                                name="freight_cost"  onChange={handleChange} 
                                value={''}/> 
                                  </div>
                                </div>
                              {/* <div class="col-md-6">
                                <label for="freight_cost" class="form-label">Freight Cost</label>
                                <input type="number" placeholder="Enter Freight Cost" ref={refs.freight_cost} class="form-control" id="freight_cost" disabled
                              name="freight_cost"  onChange={handleChange} 
                              value={''}/>
                              </div> */}
                              </>) : 

                              (<><div class="col-md-6">
                                <label for="freight_cost" class="form-label">Freight Cost</label>
                                 <div className="flex-box">
                                      <select className="form-control" name="fright_currency" style={{width:'60px'}} onChange={handleChange} value={formData.fright_currency} disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }>
                                        {displayCurrency()}

                                      </select>

                                    <input type="number" placeholder="Enter Freight Cost" ref={refs.freight_cost} class="form-control" id="freight_cost" 
                                    name="freight_cost"  
                                    onChange={handleChange} 
                                    value={formData.freight_cost}
                                    disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }
                                    required/>
                                 </div>

                              {errors.freight_cost && <span style={{ color: "red" }}>{errors.freight_cost}</span>}</div></>)} 
                              
                            
                            <div class="col-md-6">
                              <label for="tracking_number" class="form-label">Tracking Number</label>
                              <input type="number" placeholder="Enter Tracking Number" ref={refs.tracking_number} class="form-control" id="tracking_number" 
                              name="tracking_number"  onChange={handleChange} value={formData.tracking_number} disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }/>
                              {errors.tracking_number && <span style={{ color: "red" }}>{errors.tracking_number}</span>}
                            </div>

                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                              <label for="shipment_date" class="form-label">Shipment Date</label>
                              <input type="datetime-local" placeholder="Enter Freight Cost" ref={refs.shipment_date} class="form-control" id="shipment_date" 
                              name="shipment_date"  onChange={handleChange} value={formData.shipment_date} disabled={formData.status == 'pending' || formData.status == undefined || formData.status == null ? false : true }/>
                              {errors.shipment_date && <span style={{ color: "red" }}>{errors.shipment_date}</span>}
                            </div>
                           <div class="col-md-6">
                              <label for="status" class="form-label">Status</label>
                              <select class="form-select" id="status" name="status" value={formData.status} ref={refs.status}  onChange={handleChange}>
                                  <option value="">Select Type</option> 
                                  <option value="pending">Pending</option>
                                  <option value="in_transit">IN Transit</option>
                                  <option value="delivered">Delivered</option>
                                  <option value="delayed">Delayed</option>
                                  <option value="cancelled">Cancelled</option>
                              </select>
                              {errors.status && <span style={{ color: "red" }}>{errors.status}</span>}
                            </div>
                        </div>


                    <div class="row">
                      <div class="col-md-6">
                        {/* <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color">Update</button> */}
                        <Submissionbtn issaved={submitted} label={'Update'} label2={'Updating'}/>
                      </div>
                      <div class="col-md-6">
                      <button type="button" class="btn color-white w-100 rounded custom-btn-color-secondary">Close</button>
                      </div>
                      </div>
                        {/* <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color">Submit</button> */}

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditShipment;
